import React from "react";
import ReactDOM from "react-dom/client";
import { firebaseService } from "./lib/firebase";
import { seedFirestore } from "./lib/seedFirestore";
import { SystemSettingsProvider } from "./lib/SystemSettingsContext";
import App from "./App";
import "./global.css";

console.log("Initializing Firebase database...");

// Initialize Firebase and seed data
if (firebaseService.isInitialized) {
  console.log("Firebase database initialized successfully");
  
  // Seed Firestore with default data
  seedFirestore().catch(console.error);
} else {
  console.error("Failed to initialize Firebase database");
}

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <SystemSettingsProvider>
      <App />
    </SystemSettingsProvider>
  </React.StrictMode>
);

console.log("Application rendered");